<ctb-logo />

<h1>
    {{ helloWorld().message }}
</h1>

<ctb-estimator-introduction
    title="Estimez le coût de votre extension"
    description="Sélectionnez votre module d'extension et personnalisez-le pour estimer rapidement le coût de votre projet d'aménagement."
/>


<ctb-expansion-panel
    [title]="'Choisissez votre module'"
    [number]="1"
    [isOpen]="true"
>
<ctb-carousel
[id]="'232'"
[label]="'Module de choix de ville'"
[thumbnails]="[
{
    title: 'Paris',
    imageUrl: '/modules/paris2.png',
    overlayNote: 'Le plus vendu',
    id: 'thumbnail1'
},
{
    title: 'Tokyo',
    imageUrl: '/modules/tokyo.png',
    id: 'thumbnail2'
},
{
    title: 'Shanghai',
    imageUrl: '/modules/shanghai.png',
    id: 'thumbnail3'
},
{
    title: 'Venise',
    imageUrl: '/modules/venise.png',
    id: 'thumbnail4'
},
{
    title: 'Paris',
    imageUrl: '/modules/paris1.png',
    id: 'thumbnail5'
}, {
    title: 'London',
    imageUrl: '/modules/london.png',
    id: 'thumbnail6'
}
]"
>

</ctb-carousel>
</ctb-expansion-panel>


<ctb-expansion-panel
    [title]="'Choisissez vos options'"
    [number]="2"
    [isOpen]="true"
>

    <ctb-radio-groups
    [name]="'Test'"
    [options]="[
        { label: 'Parpaing', value: 'option1',  disabled: false, checked: true, ariaLabel: 'Option 1', id: 'option1' },
        { label: 'Brique', value: 'option2', disabled: false, checked: false, ariaLabel: 'Option 2', id: 'option2' },
        { label: 'Bois', value: 'option3', disabled: false, checked: false, ariaLabel: 'Option 3', id: 'option3' },
        { label: 'Autres', value: 'option4', disabled: true, checked: false, ariaLabel: 'Option 4', id: 'option4' }
    ]"
    (valueChange)="valueChanged($event)"
></ctb-radio-groups>

</ctb-expansion-panel>

<ctb-expansion-panel
    [title]="'Personnalisez votre module'"
    [number]="2"
    [isOpen]="true"
>
    <ctb-slider
    [min]="0"
    [max]="100"
    [step]="1"
    [value]="'55'"
    (valueChange)="sliderValueChanged($event)"
></ctb-slider>


</ctb-expansion-panel>


<button (click)="onButtonClick()">
    Click me
</button>
<ctb-button
    [label]="myLabel()"
    (click)="onCtbButtonClick()"
></ctb-button>

<ctb-resume
[minPrice]="32320" [maxPrice]="54030"></ctb-resume>

<router-outlet></router-outlet>
